import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { isWebsiteBuilderContainer } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { TWebsiteBuilderElement } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { IWebsiteBuilderGeneralTraversalNode } from "../../actionHelpers/generalTraversal";
import { isWebsiteBuilderFlex } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderFlex";

type TSwapFlexChildDirection = "previous" | "next";

export interface ISwapFlexChildActionPayload {
  id: string;
  index: number;
  direction: TSwapFlexChildDirection;
}

export interface ISwapFlexChildAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD;
  payload: ISwapFlexChildActionPayload;
}

export function getSwapFlexChildInverseAction(action: ISwapFlexChildAction): ISwapFlexChildAction {
  const { id, index, direction } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      id,
      index: direction === "next" ? index + 1 : index - 1,
      direction: direction === "next" ? "previous" : "next",
    },
  };
}

function swapFlexChildTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  id: string,
  index: number,
  direction: TSwapFlexChildDirection,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: IWebsiteBuilderGeneralTraversalNode): IWebsiteBuilderGeneralTraversalNode {
    if (isWebsiteBuilderContainer(node)) {
      if (isWebsiteBuilderFlex(node) && node.id === id) {
        const updatedChildren: TWebsiteBuilderElement[] = [];
        const swapIndex = direction === "next" ? index + 1 : index - 1;

        for (let i = 0; i < node.children.length; i++) {
          if (i === swapIndex) {
            updatedChildren.push(node.children[index]);
          } else if (i === index) {
            updatedChildren.push(node.children[swapIndex]);
          } else {
            updatedChildren.push(node.children[i]);
          }
        }

        return {
          ...node,
          children: updatedChildren,
        };
      } else {
        return node;
      }
    } else {
      if (!node.children) {
        return node;
      } else {
        return {
          ...node,
          children: node.children.map(traverse),
        };
      }
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}

export function applySwapFlexChildChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: ISwapFlexChildAction,
): IWebsiteBuilderHistorySnapshot {
  const { id, index, direction } = action.payload;

  return swapFlexChildTraversal(header, root, footer, id, index, direction);
}
